import { render, staticRenderFns } from "./Case.vue?vue&type=template&id=2c4369a1&scoped=true"
import script from "./Case.vue?vue&type=script&lang=js"
export * from "./Case.vue?vue&type=script&lang=js"
import style0 from "./Case.vue?vue&type=style&index=0&id=2c4369a1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.25_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_w4ow4wqgwsbk3quj5bombr2dpu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4369a1",
  null
  
)

export default component.exports